import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'slate-react';
import classNames from 'classnames';
import GalleryImage from './GalleryImage';
import DraggableGalleryImage from './DraggableGalleryImage';
import { MAX_IMAGES } from '..';

function isEqualByKey(array1, array2, key) {
  if (array1.length !== array2.length) {
    return false;
  }

  return !array1.some(function (elt, index) {
    return elt[key] !== array2[index][key];
  });
}

var Gallery =
/*#__PURE__*/
function (_Component) {
  _inherits(Gallery, _Component);

  function Gallery() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Gallery);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Gallery)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "ratios", {});

    _defineProperty(_assertThisInitialized(_this), "willUnmount", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      totalRatio: {},
      childrenDragged: false
    });

    _defineProperty(_assertThisInitialized(_this), "onLoad", function (key) {
      return function (_ref) {
        var target = _ref.target;

        var _target$getBoundingCl = target.getBoundingClientRect(),
            width = _target$getBoundingCl.width,
            height = _target$getBoundingCl.height;

        var ratio = width / height;
        _this.ratios[key] = ratio;

        _this.computeRatio();
      };
    });

    _defineProperty(_assertThisInitialized(_this), "computeRatio", function () {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.children;
      var totalRatio = children.reduce(function (acc, _ref2) {
        var key = _ref2.key;
        return acc += _this.ratios[key];
      }, 0);

      _this.setState({
        totalRatio: totalRatio
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChildrenDragged", function (dragged) {
      return !_this.willUnmount && _this.setState({
        childrenDragged: dragged
      });
    });

    return _this;
  }

  _createClass(Gallery, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref3) {
      var nextChildren = _ref3.children;

      if (!isEqualByKey(nextChildren, this.props.children, 'key')) {
        this.computeRatio(nextChildren);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.willUnmount = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          totalRatio = _this$state.totalRatio,
          childrenDragged = _this$state.childrenDragged;
      var _this$props = this.props,
          children = _this$props.children,
          editor = _this$props.editor,
          node = _this$props.node,
          attributes = _this$props.attributes,
          store = _this$props.store;
      var GalleryImageElement = editor.readOnly ? GalleryImage : DraggableGalleryImage;
      return React.createElement("div", Object.assign({
        className: classNames('image-gallery', {
          'one-image': node.nodes.size === 1
        })
      }, attributes), React.Children.map(children, function (child, index) {
        var imageWidth = _this2.ratios[child.key] / totalRatio * 100;
        return React.createElement(GalleryImageElement, {
          editor: editor,
          node: child.props.node,
          store: store,
          onChildrenDragged: _this2.onChildrenDragged,
          canDrop: childrenDragged || node.nodes.size < MAX_IMAGES,
          onLoad: _this2.onLoad(child.key),
          style: {
            width: "".concat(imageWidth, "%")
          }
        }, child);
      }));
    }
  }]);

  return Gallery;
}(Component);

_defineProperty(Gallery, "propTypes", {
  editor: PropTypes.instanceOf(Editor),
  node: PropTypes.object,
  attributes: PropTypes.any,
  children: PropTypes.any,
  store: PropTypes.any
});

export default Gallery;